module.exports = __webpack_public_path__ + "img/pic4.abd096d8.png";